import type { CustomerRow } from "../types";

export const MOCK_CUSTOMER_SUMMARY = {
  active: 142,
  pendingWelcomeLink: 3,
  total: 142,
} as const;

export const MOCK_CUSTOMERS: CustomerRow[] = [
  {
    id: "1",
    customerId: "TNT-20260515-7K9X",
    name: "Acme Financial Services Pvt Ltd",
    industryLine: "Banking · India",
    plan: "Pro",
    endpoints: 250,
    lifecycleStatus: "AWAITING_FIRST_LOGIN",
    lastActivityLabel: "15 May, 14:32",
    enabled: true,
  },
  {
    id: "2",
    customerId: "TNT-20260402-3M2P",
    name: "Renova Healthcare",
    industryLine: "Healthcare · US",
    plan: "Enterprise",
    endpoints: 1420,
    lifecycleStatus: "ACTIVE",
    lastActivityLabel: "18 May, 09:10",
    enabled: true,
  },
  {
    id: "3",
    customerId: "TNT-20260318-9L1Q",
    name: "Helix Manufacturing",
    industryLine: "Manufacturing · Germany",
    plan: "Pro",
    endpoints: 680,
    lifecycleStatus: "WELCOME_LINK_EXPIRED",
    statusDetail: "2 d ago",
    lastActivityLabel: "12 May, 16:45",
    enabled: false,
  },
  {
    id: "4",
    customerId: "TNT-20260510-4R8W",
    name: "Voyager Hospitality Group",
    industryLine: "Hospitality · UK",
    plan: "Enterprise",
    endpoints: 320,
    lifecycleStatus: "AWAITING_FORWARD_TO_CLIENT",
    lastActivityLabel: "17 May, 11:20",
    enabled: true,
  },
  {
    id: "5",
    customerId: "TNT-20260428-1H5N",
    name: "Cobalt Fintech Ltd",
    industryLine: "Financial services · Singapore",
    plan: "Pro",
    endpoints: 95,
    lifecycleStatus: "ACTIVE",
    lastActivityLabel: "18 May, 08:02",
    enabled: true,
  },
];
